import { _, Radio, Async } from "../../vendor";

const app = Radio.channel("app");

export default Async.Collection.extend({
  autoSetData: true, // automatically append data in Dependencies.ts?
  // has not yet any actual meaning

  _pagination: {
    // Updated after each request (response.pagination)
    current_page: 0,
    sort: "id",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0, // not relevant; response total entities count
    limit: 50,
  },

  parse: (response) => response.data || response,

  setPagination(pagination) {
    // Update local pagination with response pagination
    if (typeof pagination.current_page !== "undefined") {
      this._pagination.current_page = pagination.current_page;
    }
    if (typeof pagination.count !== "undefined") {
      this._pagination.count = pagination.count;
    }
    if (typeof pagination.has_prev_page !== "undefined") {
      this._pagination.has_prev_page = pagination.has_prev_page;
    }
    if (typeof pagination.has_next_page !== "undefined") {
      this._pagination.has_next_page = pagination.has_next_page;
    }
  },

  fetchNextPage(successCallback = null, deleteFilterParams = true) {
    app.trigger("collection:pagination:start");

    const collection = this,
      mergeParameter = { add: false, merge: false, remove: false };

    this.fetch(mergeParameter)
      .then((data) => {
        if (
          collection.models.length === 0 ||
          (typeof data.response.data !== "undefined" && data.response.data.length >= 1)
        ) {
          // This way we reduce unecessary calls on _setCollectionData.
          collection._setCollectionData(data.response, false);
        }

        if (
          collection._isTransactionCollection &&
          typeof data.response.data.wallet_transactions !== "undefined" &&
          data.response.data.wallet_transactions.length > 0
        ) {
          collection._setCollectionData(data.response, false);
        }

        // TEMPORARY, till generic model to handel filterParams has been found
        if (deleteFilterParams && typeof collection._filterParams !== "undefined") {
          delete collection._filterParams;
        }

        app.trigger("collection:pagination:end");

        if (successCallback) {
          successCallback(collection, data.response.data);
        }
      })
      .catch(() => {
        app.trigger("collection:pagination:end");

        this._pagination.has_next_page = false;

        if (successCallback) {
          successCallback(collection);
        }
      });
  },

  fetchFirstPage(successCallback = null, deleteFilterParams = true, sort, sortDirection) {
    app.trigger("collection:pagination:start");

    const collection = this,
      mergeParameter = { add: false, merge: false, remove: true };

    this.fetch(mergeParameter)
      .then((data) => {
        if (
          collection.models.length === 0 ||
          (typeof data.response.data !== "undefined" && data.response.data.length >= 1)
        ) {
          // This way we reduce unecessary calls on _setCollectionData.
          collection._setCollectionData2(data.response, false, sort, sortDirection);
        }
        // Backbone.sync = function(method, model) {
        //
        //   //The 'method' gives 'read' state of the model by representing data in JSON format
        //   document.write("The fetched details are: ",method + ": " + JSON.stringify(model));
        // };
        // TEMPORARY, till generic model to handel filterParams has been found
        if (deleteFilterParams && typeof collection._filterParams !== "undefined") {
          delete collection._filterParams;
        }

        app.trigger("collection:pagination:end");

        if (successCallback) {
          successCallback(collection);
        }
      })
      .catch(() => {
        app.trigger("collection:pagination:end");

        this._pagination.has_next_page = false;

        if (successCallback) {
          successCallback(collection);
        }
      });
  },

  /**
   * As the name says... returns requested element from local
   * collection or from endpoint
   *
   * Uses a copy of `this` to make a direct GET request on requested model ID.
   * (as using ?id=... filter would not be sufficient enough)
   *
   * @param {String} id
   * @param {function} successCallback With param of type Backbone.Model or null if no model found
   * @param {bool} forceFetch Set to true to update given model
   */
  fetchById(id, successCallback = _.noop, forceFetch = false) {
    let result = this.findWhere({ id: id });

    if (typeof result === "undefined" || forceFetch) {
      const that = this,
        clone = this.clone();

      clone._filterParams = {};
      clone._pagination.current_page = 0;
      clone.url += `/${id}?withTrashed=true`;

      clone.fetch({
        success(collection, response) {
          that.add(response.data);
          result = that.get(id);
          successCallback(result);
        },

        error() {
          // Not ideal, but good for temporary use
          successCallback(null);
        },
      });
    } else {
      successCallback(result);
    }
  },

  _setCollectionData(
    response,
    setProxy = true,
    mergeParameter = { add: true, merge: false, remove: false },
  ) {
    const collection = this;

    if (this._isTransactionCollection) {
      collection.preventRender = true;
      collection._saldo = response.data.saldo;
      collection.set(response.data.wallet_transactions, mergeParameter);
      collection.preventRender = false;

      collection.trigger("add", collection.models[0], collection);

      // Update local pagination data
      if (typeof this._skipPagination === "undefined") {
        if (typeof response.pagination !== "undefined") {
          collection.setPagination(response.pagination);
        }
      }

      if (
        setProxy &&
        typeof collection.proxy !== "undefined" &&
        typeof collection.proxy.models === "undefined"
      ) {
        // Set proxy used to display data in CollectionViews

        collection.proxy = new collection.proxy(collection);

        collection.proxy.setSortWithRequest = function (sort, direction) {
          // Forward changing sort to API
          // In future, this will be the main replacement of setSort

          collection.proxy.setSort(sort, direction);

          collection._pagination.sort = sort;
          collection._pagination.sortDirection = direction;
        };
      }

      return;
    }

    if (!collection.autoSetData) return;

    // Update collection, but make sure it's only re-rendered
    // once in all linked views
    collection.preventRender = true;
    //collection.add(response.data);
    collection.set(response.data, mergeParameter);
    collection.preventRender = false;

    // We MUST pass (any) parameters to avoid errors
    collection.trigger("add", collection.models[0], collection);

    // Update local pagination data
    if (typeof this._skipPagination === "undefined") {
      if (typeof response.pagination !== "undefined") {
        collection.setPagination(response.pagination);
      } else if (collection.collectionName === "orders") {
        collection._pagination.current_page++;
      }
    }

    if (
      setProxy &&
      typeof collection.proxy !== "undefined" &&
      typeof collection.proxy.models === "undefined"
    ) {
      // Set proxy used to display data in CollectionViews

      collection.proxy = new collection.proxy(collection);

      collection.proxy.setSortWithRequest = function (sort, direction) {
        // Forward changing sort to API
        // In future, this will be the main replacement of setSort

        collection.proxy.setSort(sort, direction);

        collection._pagination.sort = sort;
        collection._pagination.sortDirection = direction;

        //if (collection.collectionName !== 'orders') {
        //  collection.proxy._fetchViaReservations();
        //} else {
        //  collection.fetchNextPage();
        //}
      };
    }
  },

  _setCollectionData2(response, setProxy = true, sort, sortDirection) {
    const collection = this;

    if (!collection.autoSetData) return;

    // Update collection, but make sure it's only re-rendered
    // once in all linked views
    collection.preventRender = true;
    collection.set(response.data, { add: true, merge: true, remove: false });
    collection.preventRender = false;
    //    collection.
    // We MUST pass (any) parameters to avoid errors
    collection.trigger("add", collection.models[0], collection);

    // Update local pagination data
    if (typeof this._skipPagination === "undefined") {
      if (typeof response.pagination !== "undefined") {
        collection.setPagination(response.pagination);
      } else if (collection.collectionName === "orders") {
        collection._pagination.current_page++;
      }
    }

    collection.proxy.setSort(sort, sortDirection);
    // if (setProxy && typeof collection.proxy !== 'undefined') {
    //   if (typeof collection.proxy.models === 'undefined') {
    //     // Set proxy used to display data in CollectionViews
    //     collection.proxy = new collection.proxy(collection);
    //
    //     collection.proxy.setSortWithRequest = function(sort, sortDirection) {
    //       // Forward changing sort to API
    //       // In future, this will be the main replacement of setSort
    //
    //       collection.proxy.setSort(sort, direction);
    //
    //       collection._pagination.sort = sort;
    //       collection._pagination.sortDirection = sortDirection;
    //
    //       //if (collection.collectionName !== 'orders') {
    //       //  collection.proxy._fetchViaReservations();
    //       //} else {
    //       //  collection.fetchNextPage();
    //       //}
    //     };
    //   }
    // }
  },

  /**
   * Called from utils/Sync.tsx
   * @see https://bitbucket.org/inbooma_dev/inbooma_v2/src/master/docs/API_PAGINATION.md
   *
   * Handle pagination in requests and responses.
   */

  beforeSync(method, options) {
    if (
      method === "read" &&
      typeof this._skipPagination === "undefined" &&
      (typeof this._filterParams == "undefined" || typeof this._filterParams["id"] == "undefined")
    ) {
      options.url +=
        (options.url.indexOf("?") >= 1 ? "&" : "?") +
        `limit=${this._pagination.limit}&page=${this._pagination.current_page + 1}&sort=${this._pagination.sort}&direction=${this._pagination.sortDirection}`;
    }

    if (method === "read" && typeof this._filterParams !== "undefined") {
      // Server side filter

      let params = _.map(this._filterParams, (val, key) => key + "=" + val);

      options.url += (options.url.indexOf("?") >= 1 ? "&" : "?") + params.join("&");
    }
  },
});
